import axios from 'axios';
import authService from './AuthService';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api').replace(/\/$/, '');
const API_URL = `${API_BASE}/services`;

const getAuthHeader = () => {
    const tokenData = authService.getCurrentToken();
    if (tokenData && tokenData.access_token) {
        return { Authorization: `Bearer ${tokenData.access_token}` };
    }
    return {};
};

const getServices = () => {
    return axios.get(`${API_URL}/`, { headers: getAuthHeader() });
};

const getService = (serviceId) => {
    return axios.get(`${API_URL}/${serviceId}`, { headers: getAuthHeader() });
};

const createService = (serviceData) => {
    return axios.post(`${API_URL}/`, serviceData, { headers: getAuthHeader() });
};

const updateService = (serviceId, serviceData) => {
    return axios.put(`${API_URL}/${serviceId}`, serviceData, { headers: getAuthHeader() });
};

const deleteService = (serviceId) => {
    return axios.delete(`${API_URL}/${serviceId}`, { headers: getAuthHeader() });
};

const serviceService = {
    getServices,
    getService,
    createService,
    updateService,
    deleteService,
};

export default serviceService;
